export const ASSETS_TYPES = {
    CRIPTO: "Criptoativos",
    FUNDOS_OFFSHORE: 'Fundos Offshore',
    ACOES_OFFSHORE: 'Offshore',
    BONDS: 'Bonds',
    FUNDOS: 'Fundos de Investimentos',
    PERSONALIZADO: 'Personalizado',
    CASHBACK: 'Cashback',
}

export const RELINK_BASE_ASSET_CODES = {
    OK: 'RELINK_OK',
    BASE_SERIES_EXISTS: 'BASE_SERIES_EXISTS',
    SERIES_COPY_FAILED: 'SERIES_COPY_FAILED',
    BASE_ASSET_NAME_EXISTS: 'BASE_ASSET_NAME_EXISTS',
}
